import React, {useEffect, useState} from "react";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";

import {
    Container,
    Col,
    Warning
} from "./styles";

import routes from "../../../routes/configuration.routes";
import { useSelector } from "react-redux";
import api from "../../../service/api";
import CardPlanTax from "../../../components/CardPlanTax";

const PlansTax = () => {
    const [plans, setPlans] = useState<Array<any>>([]);
    const [refresh, setRefresh] = useState(false);
    const widthScreen = window.innerWidth;
    const login = useSelector((state: {login: any}) => state.login);
    const planVenda = login.planVenda

    useEffect(() => {
        const getActivesPlans = async (id: string) => {
            const {data} = await api.get("/branch/fees", {
                params: {
                    planBranchIdAdquirente: id
                }
            });
            
            setPlans(plans => ([...plans, data]))
        }
        
        planVenda.forEach((item: any, index: number) => {
            getActivesPlans(item.planBranchIdAdquirente)
            
            if(planVenda.length === index) {
                setRefresh(true)
            }
        });
        
    },[])

    useEffect(() => {
        if(refresh) {
            setPlans(plans)
            setRefresh(false)
        }
    }, [refresh])

    const colOne: any[] = [];
    const colTwo: any[] = [];
    const colThree: any[] = [];
    const cols = [ colOne, colTwo, colThree ];

    const generateCards = () => {
        generateCols();
        
        return cols.map((item, index) => {
            return (
                <Col key={index}>
                    {
                        item.map((item: any, index: number) => {
                            return (
                                <CardPlanTax
                                    key={index}
                                    plan={item}
                                />
                            )
                        })
                    }
                </Col>
            )
        })
    }

    const generateCols = () => {
        let count = 1
        
        return plans?.forEach((item: any) => {
            switch(count) {
                case 1:
                    if(widthScreen < 787) {
                        count = 1;
                        
                        return colOne.push(item);
                    } 
                    
                    else {
                        count ++;
                        
                        return colOne.push(item);
                    }

                case 2:
                    if(widthScreen > 788 && widthScreen < 1154) {
                        count = 1;
                        
                        return colTwo.push(item);

                    } 
                    
                    else {
                        count ++;
                        
                        return colTwo.push(item);
                    }

                case 3:
                    count = 1;
                    
                    return colThree.push(item)
                
                default:
                    return null
                }
        })
    }

    return(
        <div>
            <Header title="Configuração" subTitle="Altere as configurações gerais do sistema caso seja nescessário" subTitleWidth={271}/>
            <NavTabs tabs={routes}/>
            <Container>
                { 
                    planVenda.length !== 0
                    ? generateCards()
                    : <Warning>
                        No momento não tem nenhum plano associado ao seu estabelecimento.
                    </Warning>
                } 
            </Container>
        </div>
    )
}

export default PlansTax;